// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_j1-6";
export var emphasizeQuantity = "_j1-3";
export var flatBottomCorners = "_j1-5";
export var productImage = "_j1-0";
export var quantityContainer = "_j1-2";
export var tooltip = "_j1-1";
export var wrapAndEllipsesOverflow = "_j1-4";